<template>
	<section class="z-3005">
		<div
			class="btn-default flex flex-col items-center gap-4 overflow-hidden px-0 transition-all duration-300 min-w-60 md:min-w-73 pb-3"
			:class="containerHeight"
		>
			<!-- Header -->
			<header
				@click="toggleMenu"
				class="h-9.5 flex w-full items-center justify-between px-4 py-3 cursor-pointer hover:bg-slate-50/80 transition-colors duration-200 border-b border-slate-100"
			>
				<div class="flex items-center gap-2">
					<img src="/images/icons/stacks.svg" alt="filter icon" />
					<h3 class="text-sm font-semibold text-slate-950 capitalize">
						{{ getTranslations("filter hotspots") }}
					</h3>
				</div>
				<div>
					<img
						src="/images/icons/chevron-left.svg"
						alt="toggle icon"
						class="w-3 h-3 transition-transform duration-200"
						:class="expanded ? 'rotate-180' : ''"
					/>
				</div>
			</header>

			<!-- Layer Selection -->
			<ul
				v-if="expanded"
				class="m-0 flex list-none items-center gap-2 p-0 text-[10px] font-bold transition-all duration-300 w-full px-3"
			>
				<li
					v-for="layer in translatedLayers"
					:key="layer.id"
					@click="setLayerAndRedirect(layer)"
					class="cursor-pointer overflow-hidden capitalize transition-all duration-300 px-3 py-1 rounded-lg h-9 flex items-center justify-center"
					:class="
						isActiveLayer(layer.id)
							? 'bg-blue-400 text-white'
							: 'bg-neutral-50 text-slate-950'
					"
					v-html="layer.translation"
				/>
			</ul>

			<!-- Solutions Filters -->
			<section
				v-if="showSolutionsSection"
				class="flex flex-col gap-2 overflow-y-auto text-xs text-blue transition-all duration-300 px-3 h-full w-full"
			>
				<div class="flex flex-col justify-start gap-5">
					<!-- Portfolio Selection -->
					<div class="flex flex-col gap-2">
						<h4
							class="text-xs font-bold capitalize text-slate-600"
							v-html="getTranslations('solution portfolio')"
						/>
						<ul
							class="m-0 flex list-none flex-col items-start justify-center gap-2 overflow-hidden p-0 **:cursor-pointer"
						>
							<li
								v-for="portfolio in filteredPortfolios"
								:key="portfolio.id"
								class="relative flex items-center justify-center gap-2 pl-3 "
							>
								<input
									:id="portfolio.id"
									type="radio"
									name="portfolio-selection"
									:checked="selectedPortfolio?.id === portfolio.id"
									@change="onSelectPortfolio(portfolio)"
									class="radio-button absolute top-0 left-0 z-10 h-3.5 w-3.5  opacity-0"
								/>
								<span
									class="checkmark absolute top-0 left-0 h-3.5 w-3.5 rounded-full border border-neutral-200 bg-white"
									:class="{
										'bg-blue-400 border-blue-400':
											selectedPortfolio?.id === portfolio.id,
									}"
								/>
								<label
									:for="portfolio.id"
									class="text-slate-950 text-xs ml-2"
									:class="{
										'font-bold': selectedPortfolio?.id === portfolio.id,
									}"
									v-html="portfolio.name"
								/>
							</li>
						</ul>
					</div>

					<!-- Value Drivers Selection -->
					<div class="flex flex-col gap-2">
						<div class="justify-left flex items-center gap-1 text-black">
							<p
								class="text-xs font-bold capitalize text-slate-600"
								v-html="getTranslations('value drivers')"
							/>
						</div>
						<ul
							class="m-0 flex list-none flex-col items-start justify-center gap-2 overflow-hidden p-0 **:cursor-pointer"
						>
							<li
								v-for="valueDriver in valueDrivers"
								:key="valueDriver.id"
								class="flex items-center justify-center gap-2"
							>
								<input
									:id="valueDriver.id + '-driver'"
									type="checkbox"
									:value="valueDriver"
									v-model="selectedValueDrivers"
									@change="updateValueDrivers"
								/>
								<label
									:for="valueDriver.id + '-driver'"
									class="text-slate-950 text-xs"
									:class="{
										'font-bold': selectedValueDrivers.some(
											(driver) => driver.id === valueDriver.id,
										),
									}"
								>
									{{ valueDriver.title }}
								</label>
							</li>
						</ul>
					</div>
				</div>
			</section>
		</div>
	</section>
</template>
<script lang="js" src="./FiltersMenu"></script>
<style lang="scss" src="./FiltersMenu.scss" scoped></style>
